export const SSO_DISABLED_COPY =
  "Single sign-on isn't available at the moment. Please sign in with your email and password.";
